import { inject } from '@angular/core';

import { CheckboxState } from '@connect-services/client/lib/components/checkbox/checkbox.component';
import { FieldInterventionEntitiesFilterService } from '@connect-services/client/services/field-intervention-entities-filter.service';

export abstract class AbstractFieldInterventionEntitiesFilterOptionsComponent {
    public readonly CheckboxState = CheckboxState;
    public readonly filterEntitiesTableService = inject(FieldInterventionEntitiesFilterService);

    protected sortByCheck<T>(items: T[], checked?: string[], itemKey?: keyof T): T[] {
        return items.toSorted(
            (a, b) =>
                Number(checked?.includes(this.getValue<T>(b, itemKey))) -
                Number(checked?.includes(this.getValue<T>(a, itemKey))),
        );
    }

    private getValue<T>(item: T, itemKey?: keyof T): string {
        if (itemKey) {
            const value = item[itemKey];
            if (typeof value === 'string') {
                return value;
            }

            return String(value);
        }

        return String(item);
    }
}
